import { useState, useEffect, memo, useContext } from "react";
import style from "./../index.module.scss";
import styleUi from "./Rank.module.scss";
import { CSSTransition } from 'react-transition-group';
import * as YStyled from "../../Styleds";
import PotViewItem from "../../comm/global/components/PotViewItem";
import styled from "styled-components";
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import apiManager from './../../ApiManager';
import { GameContext } from "../../GameContext";
const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
}));
const Rank = ({ setModalType, arg, addModalType }) => {
    const { rewilding,rankRewilding,userData } = useContext(GameContext);
    const [inProp, setInProp] = useState(false);
    const [rankingFeeling, set_rankingFeeling] = useState([]);
    const [rankTypeIndex, set_rankTypeIndex] = useState(0);
    const rankType = [
        { id: 1, label: "紓壓放鬆", img: "./assets/ui/Emoji1.png" },
        { id: 2, label: "健康活力", img: "./assets/ui/Emoji2.png" },
        { id: 3, label: "超值體驗", img: "./assets/ui/Emoji3.png" },
        { id: 4, label: "精實鍛錬", img: "./assets/ui/Emoji4.png" },
        { id: 5, label: "驚險刺激", img: "./assets/ui/Emoji5.png" },
        { id: 6, label: "人潮擁擠", img: "./assets/ui/Emoji6.png" },
    ];
    const [expanded, setExpanded] = useState(false);
    const [expanded2, setExpanded2] = useState(false);
    useEffect(() => {
        setInProp(true);
        document.title = "排行榜";
    }, []);
    useEffect(() => {
        apiManager.fetchGet(`world/ranking-feelings`, { "feelings": `EXPERIENCE_${(rankTypeIndex+1)}` }, 0).then(res => {
            const _rankingFeeling = res.map(v => {
                const findRewilding = rewilding.find(r => r.rewilding_id === v.rewilding_id);
                if (findRewilding) {
                    findRewilding.rewilding_type_list = v.rewilding_type_list;
                    return findRewilding;
                }
            });
            set_rankingFeeling(_rankingFeeling);
        })
    }, [rankTypeIndex])

    return (
        <div className={style.modalBottom}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "Rank"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app}>
                                <div className={styleUi.headerBar}>
                                    <img src="./assets/ui/back.png" onClick={() => setInProp(false)} />
                                    <YStyled.Span size={17} fontWeight={700}>排行榜</YStyled.Span>
                                    <img src="./assets/ui/back.png" />
                                </div>
                                <div className={styleUi.view}>
                                    <YStyled.Row align="flex-start" gap="10px">
                                        <YStyled.Span size={17}>感受排行榜 Top 5</YStyled.Span>
                                        <img src="./assets/ui/tab4sig.svg" />
                                        <YStyled.Span size={12} color="#666" style={{ background: "white" }}>\ 由所有用戶統計而出 /</YStyled.Span>
                                    </YStyled.Row>
                                    <YStyled.Row gap="1rem" style={{ overflowX: "scroll", height: "6rem", minHeight: "6rem" }}>
                                        {rankType.map((v, k) => {
                                            return <YStyled.Col style={{ width: "4.2rem", minWidth: "4.2rem", cursor: "pointer" }} align="center" gap=".4rem" key={k} onClick={e => {
                                                set_rankTypeIndex(k);
                                            }}>
                                                <img src={v.img} style={(k === rankTypeIndex) ? { border: "solid #654721", borderRadius: "50%",width:"70%",aspectRatio:"1/1" } : {width:"70%",aspectRatio:"1/1" }} />
                                                <YStyled.Span size={14} fontWeight={400}>{v.label}</YStyled.Span>
                                            </YStyled.Col>
                                        })}
                                    </YStyled.Row>
                                    {expanded ?
                                        <>
                                            {rankingFeeling.map((v, k) => {
                                                return <PotViewItem key={k} type="rank" pot={v} onClick={pot => {
                                                    
                                                    addModalType({
                                                        cls: "PotDetail", arg: {
                                                            pot: pot,
                                                            type: "tab0",
                                                        }
                                                    })
                                                }} />
                                            })}
                                        </>
                                        :
                                        <>
                                            {rankingFeeling.slice(0, 3).map((v, k) => {
                                                return <PotViewItem key={k} type="rank" pot={v} onClick={pot => {
                                                    
                                                    addModalType({
                                                        cls: "PotDetail", arg: {
                                                            pot: pot,
                                                            type: "tab0",
                                                        }
                                                    })
                                                }} />
                                            })}
                                        </>
                                    }
                                    {rankingFeeling.length > 3 &&
                                        <YStyled.Row align="center">
                                            <YStyled.Span size={13}>{expanded ? "收合" : "展開"}</YStyled.Span>
                                            <ExpandMore
                                                expand={expanded}
                                                onClick={e => { setExpanded(!expanded); }}
                                                aria-expanded={expanded}
                                                aria-label="show more"
                                            >
                                                <ExpandMoreIcon />
                                            </ExpandMore>
                                        </YStyled.Row>
                                    }

                                    <YStyled.Row align="flex-start" gap="10px">
                                        <YStyled.Span size={17}>熱門景點 Top 5</YStyled.Span>
                                    </YStyled.Row>

                                    {expanded2 ?
                                        <>
                                            {rankRewilding.map((v, k) => {
                                                return <PotViewItem type="rank" key={k} pot={v} onClick={pot => {
                                                    
                                                    addModalType({
                                                        cls: "PotDetail", arg: {
                                                            pot: pot,
                                                            type: "tab0",
                                                        }
                                                    })
                                                }} />
                                            })}
                                        </>
                                        :
                                        <>
                                            {rankRewilding.slice(0, 3).map((v, k) => {
                                                return <PotViewItem type="rank" key={k} pot={v} onClick={pot => {
                                                    
                                                    addModalType({
                                                        cls: "PotDetail", arg: {
                                                            pot: pot,
                                                            type: "tab0",
                                                        }
                                                    })
                                                }} />
                                            })}
                                        </>
                                    }
                                    {rankRewilding.length > 3 &&
                                        <YStyled.Row align="center">
                                            <YStyled.Span size={13}>{expanded2 ? "收合" : "展開"}</YStyled.Span>
                                            <ExpandMore
                                                expand={expanded2}
                                                onClick={e => { setExpanded2(!expanded2); }}
                                                aria-expanded={expanded2}
                                                aria-label="show more"
                                            >
                                                <ExpandMoreIcon />
                                            </ExpandMore>
                                        </YStyled.Row>
                                    }
                                </div>
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(Rank);
